// extracted by mini-css-extract-plugin
var _1 = "MagneticWallLayout-module__animateUploadProgressBarWidth--zd5tR";
var _2 = "MagneticWallLayout-module__animatedBackground--eQahO";
var _3 = "MagneticWallLayout-module__container--nYs6l";
var _4 = "MagneticWallLayout-module__item--cifpD";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "container", _4 as "item" }
